import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import theme from './styles/theme';
import { Web3ProviderWrapper } from './lib/Web3Provider';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <Web3ProviderWrapper>
          <App />
        </Web3ProviderWrapper>
      </ChakraProvider>
    </BrowserRouter>
  </React.StrictMode>,
);